import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Box, FormControl, Input, InputAdornment, IconButton, Icon, SvgIcon } from '@material-ui/core'
import { Check } from '@material-ui/icons'
import { viewStyles, buttonStyles } from '../styles/styles'
import DraggableList from 'react-draggable-list'
import { changeList, deleteElement, editElement, changeNameElement, saveOptions } from '../actions/settings'

import { ReactComponent as EditIcon } from '../styles/images/edit.svg'
import { ReactComponent as BurgerIcon } from '../styles/images/burger.svg'
import { ReactComponent as TrashIcon } from '../styles/images/trash.svg'

class FormElementItem extends Component{    
    render(){
        const {item, dragHandleProps } = this.props;
        const { editingElement, editElement, deleteElement, changeName, saveOptions, btnStyles, classes } = this.props.commonProps;

        let editClass = '';
        if (editingElement !== null && editingElement.id === item.id) {
            editClass = 'active';
        }

        return(
            <Box>
                <FormControl className={classes.listRow}>
                    <Input
                        id={`form-item-${item.id}`}
                        type='text'
                        value={item.label}
                        onChange={(e) => { changeName(e.target.value, item.id, 'element') }}                    
                        endAdornment={
                        <InputAdornment position="end">
                            {
                                (item => {
                                    if(item.name !== "separator"){
                                        //if(editingElement !== null && editingElement.id === item.id){
                                        //    return(
                                        //        <IconButton size="small" onClick={() => saveOptions()}>
                                        //            <Check></Check>
                                        //        </IconButton>
                                        //    )
                                        //}else{
                                        
                                        return(
                                            <IconButton size="small"  onClick={() => editElement(item)}>
                                                <SvgIcon component={EditIcon} viewBox="0 0 9 14" className={[classes.svgIcon, editClass].join(' ')} />
                                            </IconButton>
                                        )
                                                                                                            
                                    }
                                })(item)
                            }                            
                            <IconButton size="small" onClick={() => deleteElement(item, "element")}>
                                <SvgIcon component={TrashIcon} viewBox="0 0 12 14" className={classes.svgIcon} />
                            </IconButton>
                            <Icon {...dragHandleProps} size="small" className={btnStyles.move}>
                                <SvgIcon component={BurgerIcon} viewBox="0 0 11.782 9.91" className={classes.svgIcon} />
                            </Icon>
                        </InputAdornment>
                        }
                    />
                </FormControl>
            </Box>
        )
    }
}

const FormElementsList = ({ settings, onListChange, deleteElement, editElement, changeName, saveOptions }) => {
    let _container = HTMLElement;
    const classes = viewStyles()
    const btnStyles = buttonStyles()
    return(
        <Box id="elements-container" className={classes.listElementsContainer} ref={el => { if (el) _container = el; }}>
            <Box m="0 0 10px">
                <FormControl className={classes.listRow}>
                    <Input value={settings.title} id="form-title" onChange={(e) => {changeName(e.target.value, null, 'title')}} />
                </FormControl>
            </Box>

            <DraggableList 
                itemKey="id"
                template={FormElementItem}
                list={settings.elements}
                onMoveEnd={newList => onListChange(newList)}
                commonProps={{
                    deleteElement, 
                    editingElement:settings.editingElement,
                    editElement,
                    changeName,
                    saveOptions,
                    btnStyles,
                    classes
                }}
                container={() => _container}
                 />
            
            <Box m="0 0 10px">
                <FormControl className={classes.listRow}>
                    <Input value={settings.submitText} id="form-submit" onChange={(e) => {changeName(e.target.value, null, 'submit')}} />
                </FormControl>
            </Box>
        </Box>        
    )
}

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    onListChange: newList => dispatch(changeList(newList)),
    deleteElement: (e,n) => dispatch(deleteElement(e,n)),
    editElement: (element) => dispatch(editElement(element)),
    changeName: (name, id, kind) => dispatch(changeNameElement(name, id, kind)),
    saveOptions: () => dispatch(saveOptions())
})

export default connect(mapStateToProps, mapDispatchToProps)(FormElementsList)